// ** Redux Imports
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import themeConfig from '@configs/themeConfig'

// ** Axios Imports
import axios from 'axios'

export const getAllData = createAsyncThunk('RQPermissions/getAllData', async (RQPermission) => {
  const config = {     
    headers: { 'Content-Type': 'application/json' }
}
  const getAllApi = "Requests/postall"
  const response = await axios.post(themeConfig.data.API + getAllApi, JSON.stringify(RQPermission), config)
  console.log("uuu", JSON.parse(response.data.data))
  return JSON.parse(response.data.data)
})
export const addPermission = createAsyncThunk('RQPermission/Add', async (RQPermission, { dispatch, getState }) => {
  await axios.post('http://174.142.60.74:8056/Requests/post', RQPermission)
  console.log(getState())
  await dispatch(getData(getState().RQPermission.params))
  await dispatch(getAllData())
  return RQPermission
})

export const RQPermissionsSlice = createSlice({
  name: 'RQPermissions',
  initialState: {
    data: [],
    total: 1,
    params: {},
    allData: [],
    selectedCountry: null
  },
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(getAllData.fulfilled, (state, action) => {
        state.allData = action.payload
        state.allData.data = action.payload.DataTable
        state.data = action.payload.DataTable
      })
  }
})

export default RQPermissionsSlice.reducer
